import { connect } from 'react-redux'
import { makeConditionSelector } from 'selectors/feature/conditions'
import {
  makeGetInputOptionsFiltered,
  makeSignalSelector,
  getInputSignalSwitches,
  signalsSelector,
} from 'selectors/feature/inputs'
import {
  getIsSixteenBitCanOutput,
  getHasNativeOutput,
  getIsOutputBoolean,
} from 'selectors/feature/outputs'
import { harnessPinIdSetSelector } from 'selectors/feature/harnesses'
import { getFeatureType } from 'selectors/feature/featureMetadata'

import { prop, head, has, equals, isNil } from 'ramda'
import { getFunctionOutputs } from 'selectors/feature/functions'
import { getInputRestrictionFromOutput } from 'selectors/feature/logicNodes'
import InputSignalSelector from './InputSignalSelector'

const processInputUriForSelectedSwitch = (
  uri,
  options,
  signal,
  positionArray
) => {
  const upPositionUri = options.find(({ uri: optionUri }) =>
    equals(optionUri, uri)
  )
  const hasThreePositionDown =
    has('relatedInputs', signal) && isNil(upPositionUri)
  const upInputUri = hasThreePositionDown
    ? prop('value', head(positionArray))
    : uri
  return upInputUri
}
const makeMapStateToProps = () => {
  const conditionSelector = makeConditionSelector()
  const getInputOptionsFiltered = makeGetInputOptionsFiltered()
  const currentSignalSelector = makeSignalSelector()

  return (state, ownProps) => {
    const { uri, fnId, onInputChange, selectedType } = ownProps
    const condition = conditionSelector(state, { queryUri: uri })
    const { parentType, inputUri, uriOptionsByPosition } = condition
    const currentSignal = currentSignalSelector(state, { signal: inputUri })
    const { interfacePins = null } = currentSignal
    const currentSignalSwitches = getInputSignalSwitches(state, {
      signal: inputUri,
    })
    const isSingleCondition = !parentType
    const isSixteenBitCanOutput = getIsSixteenBitCanOutput(state, {
      id: fnId,
    })
    const [output] = getFunctionOutputs(state, { id: fnId }) || []
    const restrictions = getInputRestrictionFromOutput(state, {
      id: output?.id,
    })
    const isOutputBoolean = getIsOutputBoolean(state, {
      id: fnId,
      selectedOutputId: output?.id,
    })
    const hasNativeOutput = getHasNativeOutput(state, { id: fnId })
    // The factory selector now creates per-instance selectors for the entire chain
    // including signals, so the workaround below is no longer strictly necessary.
    // However, we keep the signals dependency to ensure proper re-render on signal changes.
    const signals = signalsSelector(state)
    const inputOptions = getInputOptionsFiltered(state, {
      isSixteenBitOutput: isSixteenBitCanOutput,
      hasNativeOutput,
      isSingleCondition,
      isOutputBoolean,
      subType: selectedType,
      // Use signals hashCode for accurate change detection (not just size)
      _signalsVersion: signals ? signals.hashCode() : 0,
    })
    const pinSet = harnessPinIdSetSelector(state)
    const featureType = getFeatureType(state)
    const processedInputUri = processInputUriForSelectedSwitch(
      inputUri,
      inputOptions,
      currentSignal,
      uriOptionsByPosition
    )

    return {
      ...condition,
      isOutputBoolean,
      inputOptions,
      isSixteenBitCanOutput,
      pinSet,
      featureType,
      onInputChange,
      selectedInputUri: processedInputUri,
      currentSignalSwitches,
      inputUri,
      interfacePins,
      restrictions,
    }
  }
}

const InputSignalSelectorContainer =
  connect(makeMapStateToProps)(InputSignalSelector)

export default InputSignalSelectorContainer
